import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
   {
      path: '',
      redirectTo: 'home',
      pathMatch: 'full'
   },
   {
      path: 'home',
      loadChildren: () => import('./home/home.module').then( m => m.HomeModule)
   },

   {
      path: 'clave',
      loadChildren: () => import('./clave/clave.module').then( m => m.ClaveModule),
   },

   {
      path: 'claves',
      loadChildren: () => import('./ajustes/claves/claves.module').then( m => m.ClavesPageModule)
   },
   {
      path: 'olvido',
      loadChildren: () => import('./ajustes/olvido/olvido.module').then( m => m.OlvidoPageModule)
   },
   {
      path: 'portada',
      loadChildren: () => import('./portada/portada.module').then( m => m.PortadaPageModule)
   },


   /****************************************  NOTIFICACIONES   ************************************************ */
   {
      path: 'historiconotificaciones',
      loadChildren: () => import('./historiconotificaciones/historiconotificaciones.module').then( m => m.HistoriconotificacionesPageModule)
   },

   /****************************************  ACCESOS   ************************************************ */
   {
      path: 'camaras',
      loadChildren: () => import('./camaras/camaras.module').then( m => m.CamarasPageModule)
   },



   /****************************************  CONSUMOS   ************************************************ */
   {
      path: 'eficiencia',
      loadChildren: () => import('./eficiencia/eficiencia.module').then( m => m.EficienciaPageModule)
   },
   {
      path: 'energiasolar',
      loadChildren: () => import('./energiasolar/energiasolar.module').then( m => m.EnergiasolarPageModule)
   },
   {
      path: 'agua',
      loadChildren: () => import('./agua/agua.module').then( m => m.AguaPageModule)
   },
   {
      path: 'graficohistoricoelectrico',
      loadChildren: () => import('./graficohistoricoelectrico/graficohistoricoelectrico.module').then( m => m.GraficohistoricoelectricoPageModule)
   },
   {
      path: 'graficohistoricoagua',
      loadChildren: () => import('./graficohistoricoagua/graficohistoricoagua.module').then( m => m.GraficohistoricoaguaPageModule)
   },
   {
      path: 'graficohistoricosolar',
      loadChildren: () => import('./graficohistoricosolar/graficohistoricosolar.module').then( m => m.GraficohistoricosolarPageModule)
   },
   {
      path: 'graficohistoricoaporte',
      loadChildren: () => import('./graficohistoricoaporte/graficohistoricoaporte.module').then( m => m.GraficohistoricoaportePageModule)
   },
   {
      path: 'salamaquinas',
      loadChildren: () => import('./salamaquinas/salamaquinas.module').then( m => m.SalamaquinasPageModule)
   },




   //****************************************  MASTERCONTROL   ************************************************ */
   {
      path: 'mastercontrol',
      loadChildren: () => import('./mastercontrol/mastercontrol.module').then( m => m.MastercontrolPageModule)
   },
   {
      path: 'galeria',
      loadChildren: () => import('./mastercontrol/galeria/galeria.module').then( m => m.GaleriaPageModule)
   },
   {
      path: 'fondos',
      loadChildren: () => import('./mastercontrol/fondos/fondos.module').then( m => m.FondosPageModule)
   },
   {
      path: 'post',
      loadChildren: () => import('./mastercontrol/post/post.module').then( m => m.PostPageModule)
   },
   {
      path: 'fuente',
      loadChildren: () => import('./objetos-comunes/fuente/fuente.module').then( m => m.FuentePageModule)
   },
   {
      path: 'piscina',
      loadChildren: () => import('./objetos-comunes/piscina/piscina.module').then( m => m.PiscinaPageModule)
   },
   {
      path: 'avisos',
      loadChildren: () => import('./avisos/avisos.module').then( m => m.AvisosPageModule)
   },
   {
      path: 'tareas',
      loadChildren: () => import('./tareas/tareas.module').then( m => m.TareasPageModule)
   },
   // {
   //    path: 'domo',
   //    loadChildren: () => import('./domo/domo.module').then( m => m.DomoPageModule)
   // },
   //****************************************  UTILIDADES   ************************************************ */

   {
      path: 'postit',
      loadChildren: () => import('./post/postit/postit.module').then( m => m.PostitPageModule)
   },
   // {
   //    path: 'documents',
   //    loadChildren: () => import('./utilidades/documents/documents.module').then( m => m.DocumentsPageModule)
   // },



   //****************************************  CONSUMOS   ************************************************ */
   // {
   //    path: 'consumption',
   //    loadChildren: () => import('./consumption/consumption.module').then( m => m.ConsumptionPageModule)
   // },

   // {
   //    path: 'redelectrica',
   //    loadChildren: () => import('./consumption/redelectrica/redelectrica.module').then( m => m.RedelectricaPageModule)
   // },
   // {
   //    path: 'agua',
   //    loadChildren: () => import('./consumption/agua/agua.module').then( m => m.AguaPageModule)
   // },
   // {
   //    path: 'graficosagua',
   //    loadChildren: () => import('./consumption/graficosagua/graficosagua.module').then( m => m.GraficosaguaPageModule)
   // },

   //****************************************  SOSTENIBILIDAD   ************************************************ */
   // {
   //    path: 'sustainability',
   //    loadChildren: () => import('./sustainability/sustainability.module').then( m => m.SustainabilityPageModule)
   // },
   // {
   //    path: 'eficiencia',
   //    loadChildren: () => import('./sustainability/eficiencia/eficiencia.module').then( m => m.EficienciaPageModule)
   // },
   // {
   //    path: 'energia-solar',
   //    loadChildren: () => import('./sustainability/energia-solar/energia-solar.module').then( m => m.EnergiaSolarPageModule)
   // },
   // {
   //    path: 'wallpaper',
   //    loadChildren: () => import('./maintenance/master/wallpaper/wallpaper.module').then( m => m.WallpaperPageModule)
   // },


   //****************************************  SIN DATOS Y PRONTO DISPONIBLE   ************************************************ */
   {
      path: 'pronto-disponible',
      loadChildren: () => import('./pronto-disponible/pronto-disponible.module').then( m => m.ProntoDisponiblePageModule)
   },
   {
      path: 'sin-datos',
      loadChildren: () => import('./sin-datos/sin-datos.module').then( m => m.SinDatosPageModule)
   }
];

@NgModule({
   imports: [
      RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
   ],
   exports: [RouterModule]
})
export class AppRoutingModule { }
